import { createSamklangClient, PublicDatabaseEnvironmentSchema } from "@samklang/database";

const environment = PublicDatabaseEnvironmentSchema.safeParse(import.meta.env);

export const supabase = environment.success ? createSamklangClient(environment.data) : undefined;
export const isSupabaseConfigured = environment.success;
